import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=235a8cd5&"
import script from "./LoginPage.vue?vue&type=script&lang=js&"
export * from "./LoginPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('235a8cd5')) {
      api.createRecord('235a8cd5', component.options)
    } else {
      api.reload('235a8cd5', component.options)
    }
    module.hot.accept("./LoginPage.vue?vue&type=template&id=235a8cd5&", function () {
      api.rerender('235a8cd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/auth/LoginPage.vue"
export default component.exports